import type {EventFragmentSparse} from 'nutshell-graphql-types';

import {OpenableModals} from '../../openable-modals/openable-modals';
import {useOpenableModal} from '../../openable-modals/use-openable-modal';

import {TimelineBanner} from './timeline-banner';
import styles from './timeline-banner.module.css';

interface Props {
    event: EventFragmentSparse;
}

export function TimelineBannerFormSubmission(props: Props) {
    const {event} = props;

    /**
     * We need to include this check, even though we are only passing an event
     * with a payload.__typename of 'Lead' because Apollo doesn't generate a specific
     * enough type when using a union type (like the TimelineEventPayload).
     * See this issue for more detail:
     * https://github.com/apollographql/apollo-tooling/issues/1223
     */
    const submission = event.payload.__typename === 'Submission' ? event.payload : null;
    const form = submission?.formVersion.form;
    const submitter = submission?.primaryEntity;

    const {onOpen: onOpenSubmissionModal} = useOpenableModal(OpenableModals.FORM_SUBMISSION_MODAL, {
        submissionId: submission?.id,
        primaryEntity: submitter,
        submissionTime: event.changeTime,
        form,
    });

    if (!submission) {
        return null;
    }

    const action = (
        <span>
            submitted&nbsp;
            <span
                role='button'
                // @ts-expect-error
                tabIndex='0'
                onClick={onOpenSubmissionModal}
                className={styles['target--button']}
            >
                {form?.name}
            </span>
        </span>
    );

    return (
        <TimelineBanner
            id={event.id}
            iconVariant='form-submitted'
            timestamp={event.changeTime}
            // @ts-expect-error
            actor={submitter}
            action={action}
        />
    );
}
